import { MAX_CHAR_LENGTH } from 'common/constants/general';
import { percentFormat } from 'common/formats/formats';
import { RANGE_SENSITIVITY_SPREADSHEET_SENSITIVITY_PCT } from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getExpression, getObjectValue } from 'utilities';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import type { CustomParserPctParams, CustomParserPctReturn } from './types';
import { RANGE_SENSITIVITY_PLUS_MINUS_PREFIX } from '../../constants';

const customParserPct = (params: CustomParserPctParams): CustomParserPctReturn => {
  const { rowConfig: rc, columns: cols, tableData } = params;
  const disabled = Boolean(getObjectValue(tableData as { isDisabled?: boolean } | undefined)?.isDisabled);
  const alphabet = alphabetGenerator([], cols.length);
  const cells: Record<string, object> = {};

  const percentCellFormat = {
    ...percentFormat(),
    prefix: RANGE_SENSITIVITY_PLUS_MINUS_PREFIX,
  };

  rc.forEach((row, rowIndex) => {
    cols.forEach((column, colIndex) => {
      const rowNumber = rowIndex + 1;
      const columnLegend = alphabet[colIndex];
      const cellKey = columnLegend + rowNumber;
      const { value: columnValue } = getObjectValue(
        (column as Record<string, { value: unknown }>)[row.alias!],
      );
      const isEditableSensitivityPct =
        row.alias === RANGE_SENSITIVITY_SPREADSHEET_SENSITIVITY_PCT && !disabled;

      const parsedCell: Record<string, unknown> = {
        alias: row.alias,
        ignoreRowCopy: row.ignoreRowCopy,
        isVisible: row.isVisible,
        key: cellKey,
        rowNumber: rowIndex + 1,
        value: columnValue,
        readOnly: disabled,
        allowNegativeValue: true,
        format: percentCellFormat,
        gridType: 'number',
        ...(isEditableSensitivityPct ? { className: 'text-blue' } : {}),
      };

      cells[cellKey] = {
        ...parsedCell,
        allowEmptyValues: true,
        columnLegend,
        customKey: null,
        dbType: 'string',
        expr: getExpression({ expr: '', columnLegend }),
        format: (parsedCell.format as object) ?? null,
        gridType: parsedCell.gridType ?? 'string',
        isTextArea: false,
        maxNumberChars: MAX_CHAR_LENGTH,
        value: parsedCell.value ?? '',
      };
    });
  });

  return cells as CustomParserPctReturn;
};

export default customParserPct;
